uniform float uTime;
uniform float uIntensity;   // 0-1。GSAP でフェード
uniform vec3 uColorGreen;
uniform vec3 uColorPurple;

varying float vOffset;
varying float vColorMix;

void main()
{
    // 柔らかい円形の粒
    float dist = length(gl_PointCoord - 0.5);
    float disc = 1.0 - smoothstep(0.15, 0.5, dist);

    // 個体ごとに位相をずらしたキラキラ（明滅）
    float twinkle = 0.35 + 0.65 * (0.5 + 0.5 * sin(uTime * 2.5 + vOffset * 6.2831 * 4.0));

    vec3 color = mix(uColorGreen, uColorPurple, vColorMix);

    float strength = disc * twinkle * uIntensity;

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(color * strength, strength);
}
